enum RoutePaths {
    ROOT = '/',
    PERSONALDEVELOPMENT = '/personaldevelopment',
    ENTREPRENEURSHIP = "/entrepreneurship",
    CONTACT = "/contact",
    EDUCATION = "/education"
}

export default RoutePaths
